const PUBLIC_AUTH_PATHS = new Set([
  '/',
  '/signin',
  '/register',
  '/forgotpassword',
  '/pricing',
  '/pricingsuccess',
])

const SESSION_INVALIDATED_KEY = 'auth:session-invalidated'

export function isPublicAuthRoute(pathname) {
  const path = String(
    pathname ?? (typeof window !== 'undefined' ? window.location.pathname : ''),
  ).toLowerCase()

  return (
    PUBLIC_AUTH_PATHS.has(path) ||
    path.startsWith('/forgotpassword')
  )
}

export function hasValidAuthToken() {
  if (typeof window === 'undefined') {
    return false
  }

  try {
    const raw = window.localStorage.getItem('token')

    if (!raw || raw === 'null') {
      return false
    }

    const token = JSON.parse(raw)

    return Boolean(token)
  } catch {
    return false
  }
}

export function hasValidAuthSession() {
  if (typeof window === 'undefined') {
    return false
  }

  if (isSessionInvalidated()) {
    return false
  }

  try {
    const rawUser = window.localStorage.getItem('userData')

    if (!rawUser || rawUser === 'null') {
      return false
    }

    return hasValidAuthToken()
  } catch {
    return false
  }
}

export function isSessionInvalidated() {
  if (typeof window === 'undefined') {
    return false
  }

  try {
    return window.sessionStorage.getItem(SESSION_INVALIDATED_KEY) === '1'
  } catch {
    return false
  }
}

export function markSessionInvalidated() {
  if (typeof window === 'undefined') {
    return
  }

  try {
    window.sessionStorage.setItem(SESSION_INVALIDATED_KEY, '1')
  } catch {
    // noop
  }
}

export function clearSessionInvalidation() {
  if (typeof window === 'undefined') {
    return
  }

  try {
    window.sessionStorage.removeItem(SESSION_INVALIDATED_KEY)
  } catch {
    // noop
  }
}

let sessionExpiredHandled = false

export function handleUnauthorizedResponse(error) {
  if (error?.response?.status !== 401) {
    return false
  }

  if (sessionExpiredHandled) {
    return true
  }

  sessionExpiredHandled = true

  window.setTimeout(() => {
    sessionExpiredHandled = false
  }, 1000)

  markSessionInvalidated()

  try {
    window.localStorage.removeItem('userData')
    window.localStorage.removeItem('token')
    window.localStorage.removeItem('clientData')
  } catch {
    // noop
  }

  window.dispatchEvent(new CustomEvent('auth:session-expired'))
  return true
}

export function createUnauthorizedAxiosResponse(error) {
  return {
    data: null,
    status: 401,
    statusText: 'Unauthorized',
    headers: error?.response?.headers ?? {},
    config: error?.config,
  }
}
